// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { getVarType } from "src/lib/utils.js";

// Stateful components

export class ServiceIndicator extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {

        super(props);

        this.state = {
            "show_alerts": false,
            "pending_todo": false,
            "pending_service_indicators": false
        };

        // Binds
        this.RenderAlert = this.RenderAlert.bind(this);
        this.generateServiceIndicators = this.generateServiceIndicators.bind(this);
        this.generateTodo = this.generateTodo.bind(this);
        this.launchModal = this.launchModal.bind(this);
        this.launch_modal_to_do = this.launch_modal_to_do.bind(this);
        this.launch_modal_service_indicators = this.launch_modal_service_indicators.bind(this);
        this.showServiceIndicatorContent = this.showServiceIndicatorContent.bind(this);
        this.showChecklistContent = this.showChecklistContent.bind(this);
    }

    componentDidMount(){
        var this_component = this;
        // check if alerts need to be shown
        var alerts = this_component.determineIfAlertsShouldShow();
        // if at least one alert type needs to be shown set state
        // at least one of the values will be true if alert['userHasAlerts'] is true
        if(alerts['userHasAlerts']){
            this_component.setState({
                "show_alerts": alerts['userHasAlerts'],
                "pending_todo": alerts['userHasTodoList'],
                "pending_service_indicators": alerts['userHasServiceIndicators']
            });
        }
    }


    // Functions
    determineIfAlertsShouldShow(){
        var this_component = this;
        var portal_context = this_component['context'];
        var user_attributes = portal_context['user_personalisation'];

        var userHasAlerts = false;
        var userHasTodoList = false;
        var userHasServiceIndicators = false;
        
        var alertType = '';
        var serviceIndicators = '';
        var toDoList = '';

        // get the personalisation attributes
        if(user_attributes['attributes']){
            user_attributes = user_attributes['attributes'];
            serviceIndicators = user_attributes['SRV_INDCTR'];
            toDoList = user_attributes['TO_DO_LIST'];
        
            //
            // SERVICE INDICATORS
            //
            // cater for string or object/array versions of the data

            var valid_indicators = ['PVAD', 'LPVAD', 'PVALL', 'TRAN'];

            if(typeof(serviceIndicators) !== 'undefined') {

                if (typeof serviceIndicators === 'string'){
                    if (serviceIndicators.length > 0){
                        for (var i in valid_indicators) {
                            if (serviceIndicators.indexOf(valid_indicators[i]) !== -1) {
                                userHasAlerts = true;
                                userHasServiceIndicators = true;
                            }
                        }
                    }
                } else {
                    // special case for fees specifically on the courses page
                    if (alertType === "fees"){
                        if (typeof(serviceIndicators) !== "undefined") {
                            for (var i in valid_indicators) {
                                if (typeof(serviceIndicators[valid_indicators[i]]) !== "undefined") {
                                    userHasAlerts = true;
                                    userHasServiceIndicators = true;
                                }
                            }
                            if (!userHasAlerts) {
                                // array
                                for(var index = 0; index < serviceIndicators.length; index++){
                                    for (var i in valid_indicators) {
                                        if (serviceIndicators[index].indexOf(valid_indicators[i]) !== -1){
                                            userHasAlerts = true;
                                            userHasServiceIndicators = true;
                                        }
                                    }
                                }
                            }
                        }
                    } else if(Array.isArray(serviceIndicators)) {
                        for(var key in serviceIndicators){
                            var item = serviceIndicators[key];
                            var itemKey = key;

                            // if((typeof(item) === 'string') || item === true){
                            //     if(item === 'PVAD' || item === 'LPVAD' || item === 'PVALL'){
                            //         userHasAlerts = true;
                            //         userHasServiceIndicators = true;
                            //     }
                            //     if(itemKey === 'PVAD' || itemKey === 'LPVAD' || itemKey === 'PVALL'){
                            //         userHasAlerts = true;
                            //         userHasServiceIndicators = true;
                            //     }
                            // }

                            if (typeof(item['NSI_CDE']) !== 'undefined') {
                                userHasAlerts = true;
                                userHasServiceIndicators = true;
                            }
                        }
                    } else {
                        // Single NSI as an object
                        if (typeof(serviceIndicators['NSI_CDE']) !== 'undefined') {
                            userHasAlerts = true;
                            userHasServiceIndicators = true;
                        }
                    }
                }
            }

            //
            // TO DO LIST
            //
            
            if(typeof(toDoList) !== 'undefined') {
                var todo_type = getVarType(toDoList);

                if(todo_type === 'array') {
                    if(toDoList.length > 0) {
                        userHasAlerts = true;
                        userHasTodoList = true;
                    }
                } else {
                    userHasAlerts = true;
                    userHasTodoList = true;
                }
            }
        }
        
        return {
            "userHasAlerts": userHasAlerts,
            "userHasTodoList": userHasTodoList,
            "userHasServiceIndicators": userHasServiceIndicators
        };
    }


    // 
    // modals
    //
    launchModal(modalTitle, modalContent){
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        
        var modal_content = null;
        var modal_title = null;
        // compose iframe
        modal_content = modalContent;
        
        var modal_buttons = this_component.renderModalButtons();

        // Get modal data
        var modal_data = {
            'title': modalTitle,
            'class': 'modal-service-indicators',
            'content': modal_content,
            'buttons': modal_buttons
        };

        // Set modal content and display
        helpers.setModalContent(modal_data);
    }

    getModalData(data_type, successCallback) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        var force_refresh = false;

        // Get API data
        helpers.checkForGatekeeperData(successCallback, data_type, force_refresh);
    }

    showServiceIndicatorContent(nsi) {
        var this_component = this;
        var portal_context = this_component['context'];
        var my_service_indicators_storage = squiz.fn.getStorage('getmynegativeserviceindicator', 'session', 'json');

        console.log('test');
        if(my_service_indicators_storage && my_service_indicators_storage['data']){
            var modal_title = nsi['message'];
            var modal_content = this_component.generateServiceIndicators(my_service_indicators_storage, nsi);

            this_component.launchModal(modal_title, modal_content);
        } else {
            
        }
    }

    showChecklistContent() {
        var this_component = this;
        var portal_context = this_component['context'];
        var my_todo_storage = squiz.fn.getStorage('getmychecklist', 'session', 'json');

        if(my_todo_storage && my_todo_storage['data']){
            var modal_title = portal_context['configuration']['contextual_messages']['to_do_list'];
            var modal_content = this_component.generateTodo(my_todo_storage);

            this_component.launchModal(modal_title, modal_content);
        } else {
            
        }
    }

    launch_modal_service_indicators(event, nsi){
        event.preventDefault();
        var this_component = this;
        var successCallback = (data) => this_component.showServiceIndicatorContent(nsi, data);

        // fetch data for modal
        this_component.getModalData('service_indicators', successCallback);
    }

    launch_modal_to_do(event){
        event.preventDefault();
        var this_component = this;
        var successCallback = this_component.showChecklistContent;

        // fetch data for modal
        this_component.getModalData('checklist', successCallback);
    }

    //
    // Render
    //
    renderModalButtons() {
        return (
            [{
                'class': 'btn btn-secondary',
                'label': 'Close',
                'clickHandler': null,
                'action': 'close'
            }]
        );
    }

    generateServiceIndicators(props, nsi){
        var this_component = this;
        var data = props['data'];
        var nsi_data = null;

        if(data){
            nsi_data = data['nsis'];
        }

        var portal_context = this_component['context'];
        
        var nsi_content = null;
        var nsi_description = nsi['title'];
        if(nsi_data){
            nsi_content = nsi_data.map(function(item, index){
                if (item['description'] === nsi['description']) {
                    return (
                        <div className="alert-modal" key={index}>
                        <div className="alert-modal__inner">
                            <div className="alert-modal__content">

                                <h2 className="alert-modal__title">{item['description']}</h2>

                                <div className="alert-modal__content-wrapper">
                                    <div className="alert-modal__content--contact">
                                        <h3 className="alert-modal__content--title">Contact</h3>
                                        <div className="alert-modal__content--inner">

                                            <div className="alert-modal__content--item">
                                                <h4 className="alert-modal__content--item-title">Start Date</h4>
                                                <div className="alert-modal__content--item-value">{item['activeDate']}</div>
                                            </div>

                                            <div className="alert-modal__content--item">
                                                <h4 className="alert-modal__content--item-title">Start Term</h4>
                                                <div className="alert-modal__content--item-value">{item['startTerm']}</div>
                                            </div>


                                            {item['nsiAmount'] ? (
                                                <>
                                                {item['nsiAmount'] !== '0' ? (
                                                    <div className="alert-modal__content--item">
                                                        <h4 className="alert-modal__content--item-title">Amount</h4>
                                                        <div className="alert-modal__content--item-value">${item['nsiAmount']}</div>
                                                    </div>
                                                ) : null}
                                                </>
                                            ) : null }
                                            
                                            
                                        </div>
                                    </div>

                                    {item['longDescription'] ? (
                                        <div className="alert-modal__content--description">
                                            <h3 className="alert-modal__content--title">Description</h3>
                                            <p className="alert-modal__content--item-value" dangerouslySetInnerHTML={{__html: item['longDescription']}}></p>
                                        </div>
                                    ) : null}
                                    
                                </div>
                            </div>
                        </div>
                        </div>
                    );
                }
            });
    
            return (
                <>
                <p className="alert-modal--header-description" dangerouslySetInnerHTML={{__html: nsi_description}}></p>
                {nsi_content}
                </>
            );
        }

        return null;
    }

    generateTodo(props){
        var this_component = this;
        var checklist_data = props['data'];
        var portal_context = this_component['context'];

        var todo_content = null;
        var todo_description = portal_context['configuration']['contextual_messages']['to_do_list_description'];

        if(checklist_data){
            todo_content = checklist_data.map(function(item, index){
                return (
                    <div className="alert-modal" key={index}>
                        <div className="alert-modal__inner">
                            <div className="alert-modal__content">

                                <h2 className="alert-modal__title">{item['toDoDescription']}</h2>

                                <div className="alert-modal__content-wrapper">
                                    <div className="alert-modal__content--contact">
                                        <h3 className="alert-modal__content--title">Contact</h3>
                                        <div className="alert-modal__content--inner">

                                            <div className="alert-modal__content--item">
                                                <h4 className="alert-modal__content--item-title">Status</h4>
                                                <div className="alert-modal__content--item-value">{item['toDoStatus']}</div>
                                            </div>

                                            <div className="alert-modal__content--item">
                                                <h4 className="alert-modal__content--item-title">Due date</h4>
                                                <div className="alert-modal__content--item-value">{item['toDoDueDate']}</div>
                                            </div>

                                            <div className="alert-modal__content--item">
                                                <h4 className="alert-modal__content--item-title">Contact</h4>
                                                <div className="alert-modal__content--item-value"><a href={'mailto:' + item['toDoContactEmailAddress']}>{item['toDoContactName']}</a></div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className="alert-modal__content--description">
                                        <h3 className="alert-modal__content--title">Description</h3>
                                        <p className="alert-modal__content--item-value">
                                            {item['toDoItemInstruction'].split("\n").map((i,key) => {
                                                return <span key={key}>{i}<br /></span>;
                                            })}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });

            return (
                <>
                <p className="alert-modal--header-description" dangerouslySetInnerHTML={{__html: todo_description}}></p>
                {todo_content}
                </>
            );
        }

        return null;
    }


    RenderAlert(){
        var this_component = this;
        var portal_context = this_component['context'];
        
        var userHasAlerts = this_component['state']['show_alerts'];
        var userHasServiceIndicators = this_component['state']['pending_service_indicators'];
        var userHasTodoList = this_component['state']['pending_todo'];

        var todo_message = portal_context['configuration']['contextual_messages']['to_do_list'];
    
        var alert_classnames = 'alert__title';
        if(userHasServiceIndicators && userHasTodoList){
            alert_classnames = 'alert__title alert__title--group';
        }

        var active_nsi = [];

        for (var i in portal_context['user_personalisation']['attributes']['SRV_INDCTR']) {
            var message = 'service_indicators_' + portal_context['user_personalisation']['attributes']['SRV_INDCTR'][i]['SRVC_IND_CD'].toLowerCase();
            var title = 'service_indicators_' + portal_context['user_personalisation']['attributes']['SRV_INDCTR'][i]['SRVC_IND_CD'].toLowerCase() + '_description';

            var nsi = {
                'code': portal_context['user_personalisation']['attributes']['SRV_INDCTR'][i]['SRVC_IND_CD'],
                'description': portal_context['user_personalisation']['attributes']['SRV_INDCTR'][i]['NSI_DESCR'],
            };

            if (portal_context['configuration']['contextual_messages'][message]) {
                nsi.message = portal_context['configuration']['contextual_messages'][message]
                nsi.title = portal_context['configuration']['contextual_messages'][title]
            } else {
                nsi.message = portal_context['configuration']['contextual_messages']['service_indicators']
                nsi.title = portal_context['configuration']['contextual_messages']['service_indicators_description']
            }
            active_nsi.push(nsi);
        }

        if(userHasAlerts){
            return (
                <>
                {userHasServiceIndicators && active_nsi.map((nsi) => (
                    <div className="alert__wrapper inner" key={nsi['code']}>
                        <div className="alert">
                            <div className="alert__icon" dangerouslySetInnerHTML={{__html: require('../../SVGs/html/warning-icon.html')}}></div>
                            <div className="alert__content">
                                 <a href="#" className={alert_classnames} onClick={(e) => this_component.launch_modal_service_indicators(e, nsi)}>{nsi['message']} - <span>view details</span></a>
                            </div>
                        </div>
                    </div>
                ))}
                {userHasTodoList &&
                    <div className="alert__wrapper inner">
                        <div className="alert">
                            <div className="alert__icon" dangerouslySetInnerHTML={{__html: require('../../SVGs/html/warning-icon.html')}}></div>
                            <div className="alert__content">
                                <a href="#" className={alert_classnames} onClick={this_component['launch_modal_to_do']}>{todo_message} - <span>view details</span></a>
                            </div>
                        </div>
                    </div>
                }   
                </>
            );
        }
        return null;
    }

    render() {
        var this_component = this;
        // return dev
        return (
            <>
                <this_component.RenderAlert/>
            </>
        );
    }

};

ServiceIndicator.contextType = PortalContext;
